import { IApplicationState } from 'setup/store'

import { FeatureFlagNames, isFeatureEnabled } from 'shared/utils/featureFlags'

export const selectCurrenciesList = (state: IApplicationState) => state.settings.data.currencies
export const selectSettings = (state: IApplicationState) => state.settings.data

export const selectRequirePasswordChangeEnabled = (state: IApplicationState) => {
  const { featureFlags } = state.settings.data
  
  return isFeatureEnabled(featureFlags, FeatureFlagNames.REQUIRE_PASSWORD_CHANGE_ENABLED)
}